<template>
  <div class="kbli-container">
    <div class="modal-company-kbli-wrapper">
      <div class="list-perizinan">
        <div class="text-bold column5">No</div>
        <div class="text-bold column50">Jenis</div>
        <div class="text-bold column20">Bidang</div>
        <div class="text-bold column30">Sub Bidang</div>
      </div>
      <div
        class="list-perizinan"
        v-if="iujpVendor.length > 0"
        v-for="(list, index) in iujpVendor"
        :key="index"
      >
        <div class="column100 flex-row mt10" v-show="list && list.master_iujp">
          <div class="column5">{{ index + 1 }}</div>
          <div class="column50">{{ $get(list, 'master_iujp.jenis') }}</div>
          <div class="column20">{{ $get(list, 'master_iujp.bidang') }}</div>
          <div class="column30">{{ $get(list, 'master_iujp.sub_bidang') }}</div>
        </div>
      </div>
    </div>

    <div class="kbli-mobile-container for-mobile">
      <div
        class="kbli-mobile-list"
        v-if="iujpVendor.length > 0"
        v-for="(list, index) in iujpVendor"
        :key="index"
      >
        <div class="w-full text-gray">Jenis</div>
        <div class="w-full">{{ $get(list, 'master_iujp.jenis') }}</div>
        <div class="w-full text-gray">Bidang</div>
        <div class="w-full">{{ $get(list, 'master_iujp.bidang') }}</div>
        <div class="w-full text-gray">Sub Bidang</div>
        <div class="w-full">{{ $get(list, 'master_iujp.sub_bidang') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    iujpVendor() {
      let data = this.$store.state.level1.iujpVendor
      data = data.filter(i => i.master_iujp != null)
      return data
    },
  },
  created() {},
  methods: {},
}
</script>
